import IconStatCard from './IconStatCard';

export default IconStatCard;